import { api } from './api';

/* CLEAN-ARCH (Vague 4) : profil du caller via les ports tRPC (scopé server-side), */
/* au lieu de supabase-js direct. Les paramètres userId sont conservés pour la */
/* signature mais ignorés (le backend utilise le user du JWT). */
export async function getMyFirstName(_userId?: string): Promise<string | null> {
  return api.profile.firstName.query();
}

export interface ProfileNames {
  first_name: string | null;
  last_name: string | null;
}

export async function getMyProfileNames(_userId?: string): Promise<ProfileNames> {
  return api.profile.names.query();
}

export async function updateMyProfileNames(_userId: string, input: { firstName: string; lastName: string }): Promise<void> {
  await api.profile.updateNames.mutate(input);
}
